import React from "react"

type PhoneLinkProps = {
  phone?: string
  labelPrefix?: string
} & React.HTMLProps<HTMLAnchorElement>

const PhoneLink = (props: PhoneLinkProps) => {
  const { phone, labelPrefix, ...rest } = props
  if (!phone) {
    return null
  }
  const label = labelPrefix ? `${labelPrefix} ${phone}` : phone
  return (
    <a itemProp="telephone" {...rest} href={`tel:${phone.replace(/[^\d+]/g, "")}`}>
      {label}
    </a>
  )
}

export default PhoneLink
